<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-2-changing-friendships">
<h1>Chapter 2 – Changing <br/>Friendships</h1>
<p>Friday morning in early November was bright with sunshine, wet from the morning dew on the grass, and humid, as it was at the end of the rainy season.</p>
<p>Ying walked home past the sugarcane fields. She was glad that even here farmers planted sugarcane; it reminded her of home, less than one hundred kilometres away from the dormitory where she resided during the time she studied to become a teacher.</p>
<p>“Hi!” called out Ying as she saw Dao walking towards the same place where she was also going.</p>
<p>“Hi!” answered Dao. “Are you excited? Did your parents come yet?”</p>
<p>Many parents travelled hundreds of kilometres for their son’s or daughter’s graduation even from other provinces.</p>
<p>“Not yet, as the graduation is tomorrow. They’ll be arriving tonight. I’ll pack up and go home with them then together,” said Ying.</p>
<p>“You’re lucky to have gotten that teacher’s summer job near your hometown,” commented Dao.</p>
<p>Ying became thoughtful. “I don’t know,” she began, “is it the best choice to work near home? I’ll have to teach the students these concepts of forest conservation, sustainability and water conservation techniques along with irrigation. These will certainly bring in anxiety and tensions for the students’ families who are involved in illegal lumbering and poaching.”</p>
<p>“Oh, and those hill tribes. It’s difficult to even understand, what they’re trying to say, as their Thai language is not quite up-to-standard,” Ying continued.</p>
<p>“Of course, but then they are often fluent in French, Burmese, and perhaps Chinese in addition to their own hill-tribe languages.”</p>
<p>“How do you know?” asked Ying. “And why do you always have to take their side?!” Ying was quite cross at her friend. What had happened to their friendship? Was something new happening that she was unaware of?</p>
<p>“I’m not!” vehemently answered her friend Dao. “I’m just trying to rationalize matters. In addition, they’re actually quite clever.”</p>
<p>Ying remembered the younger hill-tribe girl who had moved in to assist in Bussaba’s shop. Did she exert some influence on her friend Dao? Would their friendship last? she wondered.</p>
<p>The girls arrived at the school auditorium and quietly entered the hallway along with the two hundred other students. Teachers Bundit and Parin were both ushering in students to sit with their own classes in consecutive rows for this grand rehearsal.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?5407efc3